import { render, staticRenderFns } from "./ManageAreaQuestions.vue?vue&type=template&id=3d420796"
import script from "./ManageAreaQuestions.vue?vue&type=script&lang=js"
export * from "./ManageAreaQuestions.vue?vue&type=script&lang=js"
import style0 from "./ManageAreaQuestions.vue?vue&type=style&index=0&id=3d420796&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports